import React, { Component, Fragment } from 'react';
import { array, arrayOf, bool, func, number, object, shape, string, oneOfType } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './MarketPricingContainer.scss';
import ViewSwitcher from 'ps-components/ViewSwitcher/ViewSwitcher';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import {
  getConfigSettings,
  setDisplayIn as setDisplayInCSR,
  setSelectedBenchmarkYear as setBenchmarkYearCSR
} from '../CompensationSummary/CompensationSummaryActions';
import InternalJobsContainer from './InternalJobs/InternalJobsContainer';
import SurveyLibrary from './SurveyLibrary/SurveyLibrary';
import JobPricingContainer from './JobPricing/JobPricingContainer';
import SlottedJobSearch from './SlottedJobSearch/SlottedJobSearch';
import {
  getAgingFactors,
  getJobByID,
  resetOrgJobsLoading,
  updateJobMatchesValues
} from '../JobMatching/OrgJobsActions';
import { getHeaderInfo, getOverallComposite, setYearOverYearDisplayIn } from './../YearOverYear/YearOverYearActions';
import {
  addSelectedCutID,
  getJobPricingDetails,
  getLastModifiedDate,
  getPricingViews,
  getRangeChartData,
  getSelectedPricingView,
  removeSelectedCutID,
  resetJobPricingReducer,
  setSelectedAgingFactor,
  setSelectedBenchmarkYear,
  setSelectedPricingView,
  updateAgingFactor,
  updateMeritMatchSummaries
} from './JobPricing/JobPricingActions';
import { initializeSaveJobPricingWithJob } from './Save/SaveJobPricingActions';
import { resetInternalJobsReducer, updateSelectJob } from './InternalJobs/actions/InternalJobsActions';
import { createAdHocJob } from '../SkillGeoDifferential/SkillGeoDifferentialActions';
import {
  addMatch,
  changeStatus,
  deleteMatch,
  downloadJobDescription,
  getSelectedSurveyView,
  getSurveyViews,
  resetReportDropdown,
  setDisplayIn,
  setReportDropdown,
  setSelectedSurveyView
} from './MarketPricingActions';
import { jobMatchGridActions } from './LandingPage/JobMatchDetail/JobMatchGridCreate';

import MarketplaceMatches from './MarketplaceMatches/MarketplaceMatches';
import * as marketplaceMatchesActions from './MarketplaceMatches/MarketplaceMatchesActions';
import { marketplaceMatchesGridActions } from './MarketplaceMatches/MarketplaceMatchesGrid/MarketplaceMatchesGridCreate';

import ParticipationMatchesContainer from './ParticipationMatches/ParticipationMatches';
import * as participationMatchesActions from './ParticipationMatches/ParticipationMatchesActions';
import { participationMatchesGridActions } from './ParticipationMatches/ParticipationMatchesGrid/ParticipationMatchesGridCreate';

import { Link, withRouter } from 'react-router-dom';
import { SLIDEOUTS as MP_SLIDEOUTS } from '../Slideout/Slideouts';
import { showSlideout, hideSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { getCurrentAgingCode, isAdHocJobId } from './helper';
import { getColumnIndex } from 'ps-components/AdvancedTable/GenericGrid/GenericGridHelper';
import SubLabelList from 'ps-components/SubLabelList/SubLabelList';
import { ALL_CURRENCIES_CODE } from '../../reducers/modules/currency/currency';
import classnames from 'classnames';
import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import { DISPLAY_IN_TYPE } from '../../lib/displayIn';
import { PAGE, PAGE_CODE, CATEGORY_CODE } from '../../lib/pageCodeDefaults';
import { internalJobsGridActions } from './InternalJobs/InternalJobsGrid/InternalJobsGridCreate';
import { surveyLibraryGridActions } from './SurveyLibrary/grid/SurveyLibraryGridCreate';
import { surveyLibraryFacetActions } from './SurveyLibrary/facet/SurveyLibraryFacet';
import { jobPricingGridActions } from './JobPricingDetails/JobPricingGrid/JobPricingGridCreate';
import { NEW_MARKET_PRICING_URL } from '../../containers/Home/Home';
import { shortDateString } from 'ps-components/lib/formatters';
import { PRICING_TYPE } from '../SkillGeoDifferential/SkillGeoDifferentialReducer';
import { slottedSearchGridActions } from './SlottedJobSearch/SlottedGrid/SlottedGridCreate';
import { slottedSearchJobFacetSearchActions } from './SlottedJobSearch/SlottedSearchFacet';
import * as slottedSearchActions from './SlottedJobSearch/SlottedSearchActions';
import { getEmployeeSelectedView, getJobEmployees } from './JobEmployees/JobEmployeesActions';
import { getJobDetailsSelectedView } from './JobDetails/JobDetailsActions';
import { Modal } from 'ps-design';
import ModalBody from 'ps-components/Modal/ModalBody/ModalBody';
import ModalHeader from 'ps-components/Modal/ModalHeader/ModalHeader';
import SlotteeInfo from './SlotteeInfo/SlotteeInfo';
import DropdownViews from 'ps-components/Dropdown/DropdownViews';
import { jdxActions, jdxTitles } from '../HRTMS/JDXUtils';
import { capitalizeFirstLetter } from 'ps-components/lib/formatters';
import { AIMatching } from './AIMatching/AIMatching';
import { Tooltip } from '@mantine/core';

const DETAILS_TAB = 0;
const SEARCH_TAB = 1;

const SURVEY_LIBRARY_MATCHES = 0;
const AI_MATCHING = 1
const COPY_MATCHES = 2;
const MARKETPLACE_MATCHES = 3;
const PARTICIPATION_MATCHES = 4;
const PRICING_PATH_INDEX = 5;

const SLOTTED_PATH_INDEX = 6;
const SLOTTED_SEARCH_PATH_INDEX = 7;

const MIN_HEADER_LIMIT = 160;

class MarketPricingContainer extends Component {
  static propTypes = {
    history: object,
    actions: shape({
      createAdHocJob: func,
      deleteMatch: func,
      downloadJobDescription: func,
      getAgingFactors: func,
      getConfigSettings: func,
      getEmployeeSelectedView: func,
      getJobDetailsSelectedView: func,
      getJobEmployees: func,
      getJobByID: func,
      getLastModifiedDate: func,
      getPricingViews: func,
      getSelectedPricingView: func,
      getSelectedSurveyView: func,
      getSurveyViews: func,
      hideSlideout: func,
      initializeSaveJobPricingWithJob: func,
      resetInternalJobsReducer: func,
      resetJobPricingReducer: func,
      resetReportDropdown: func,
      setDisplayIn: func,
      setReportDropdown: func,
      setSelectedAgingFactor: func,
      setSelectedBenchmarkYear: func,
      setSelectedPricingView: func,
      setSelectedSurveyView: func,
      showSlideout: func,
      updateAgingFactor: func,
      updateJobMatchesValues: func,
      updateMeritMatchSummaries: func
    }),
    replacementTokens: array,
    useJobCodeKey: bool,
    defaultBenchmarkYear: number,
    benchmarkYears: arrayOf(number),
    isAgingReducerLoaded: bool,
    selectedSurveys: array,
    adHocJob: shape({
      orgJobCode: string,
      orgJobCodeKey: string
    }),
    match: object,
    internalJobs: object,
    isAgingFactorsLoaded: bool,
    isUpdatingAgingFactor: bool,
    currency: object,
    currencies: array,
    jobPricing: shape({
      pricingViews: arrayOf(
        shape({
          viewName: string,
          viewPk: number
        })
      ),
      selectedAgingFactor: string,
      selectedViewPk: number,
      selectedViewSlottedPk: number,
      setSelectedPricingViewSuccess: bool,
      isUpdatingAgingFactor: bool,
      isUpdatingAgingFactorFailed: bool,
      isPricingMatchDeleting: bool,
      isPricingMatchDeleteFailed: bool,
      isUpdatingMeritMatchSummaries: bool
    }),
    marketPricing: shape({
      displayIn: string,
      reportDropdownOption: string,
      surveyViews: shape({
        views: array,
        loading: bool,
        loaded: bool
      }),
      surveySelectedView: shape({
        selectedViewPk: number,
        loading: bool,
        loaded: bool
      }),
      setSurveyView: shape({
        loading: bool
      }),
      surveyError: string,
      loadingId: oneOfType([string, number]),
      isMatchDeleting: bool,
      jobDescription: shape({
        fileType: string,
        downloadURL: string,
        previewURL: string,
        hasHRTMS: bool
      }),
      uploadJobDescriptionLoading: bool,
      deleteJobDescriptionLoading: bool,
      downloadJobDescriptionLoading: bool,
      jobDescriptionError: string,
      changeStatus: shape({
        loading: bool,
        error: string
      })
    }),
    isLoadingOrgJob: bool,
    isLoadingOrgJobFailed: bool,
    jobs: array,
    isJobMatchUpdating: bool,
    agingFactors: array,
    isJobMatchUpdateFailed: bool,
    isGetJobPricingFailed: bool,
    isGetJobPricingLoading: bool,
    readOnlyUser: bool,
    isGetJobPricingLoaded: bool,
    internalJobsGrid: object,
    masterAccountId: oneOfType([number, string]),
    surveyLibraryGridActions: object,
    surveyLibraryGrid: object,
    surveyLibraryFacet: object,
    surveyLibraryFacetActions: object,
    jobPricingGrid: object,
    jobPricingGridActions: object,
    fieldFormatting: shape({
      numericRounding: number,
      monetaryRounding: number,
      percentRounding: number
    }),
    isSavingDataCutChangesComplete: bool,
    organizationCode: string,
    selectedSlottedJobs: array,
    location: object,
    siteSettings: shape({
      showAgingFactor: bool,
      showWgtBy: bool,
      useParticipationMatch: bool,
      showGeoAdjustment: bool
    }),
    slottedSearchGridActions: object,
    slottedSearchFacetActions: object,
    slottedSearchActions: object,
    slottedSearch: object,
    defaultWeighting: string,
    editPastYears: bool,
    editPastYearsGroup: bool,
    sameOrgAndGroup: bool,
    hasHRTMSIntegration: bool,
    launchDarklyFeatureFlags: object,
    uniqueSalaryRange: bool,
    useCurrencyBasedAgingFactor: bool,
    restrictedUser: bool
  };

  tabPaths = [
    'survey-library',
    'ai-matching',
    'copy-matches',
    'marketplace',
    'participation-matches',
    'pricing',
    'slotted',
    'slotted-search'
  ];

  tabMapping = {
    'Survey Library Matches': SURVEY_LIBRARY_MATCHES,
    'AI Matching': AI_MATCHING,
    'Copy Matches': COPY_MATCHES,
    'Marketplace Matches': MARKETPLACE_MATCHES,
    'Participation Matches': PARTICIPATION_MATCHES,
  };

  constructor(props) {
    super(props);

    const tabIndex = this.tabPaths.indexOf(props.match.params.tab);

    let initialTabIndex = this.isAdHocJob() ? SEARCH_TAB : DETAILS_TAB;
    let initialAddMatchesIndex = SURVEY_LIBRARY_MATCHES;

    // If invalid url endpoint, navigate back to landing page
    if (tabIndex === -1 || this.getJobId() === null) {
      props.history.push(NEW_MARKET_PRICING_URL);
    } else {
      // If url is /pricing, then start on pricing-details tab
      if (tabIndex === PRICING_PATH_INDEX || tabIndex === SLOTTED_PATH_INDEX) {
        initialTabIndex = DETAILS_TAB;
      } else {
        initialTabIndex = SEARCH_TAB;
        initialAddMatchesIndex = tabIndex;
      }
    }
    const currency = props.currency.code !== ALL_CURRENCIES_CODE ? props.currency.code : null;

    this.state = {
      currency,
      currentJob: null,
      isLoadingJob: false,
      renderPopover: false,
      selectedAddMatchesIndex: initialAddMatchesIndex,
      selectedRowId: 0,
      selectedTabIndex: initialTabIndex,
      showMinHeader: false,
      usedJobs: []
    };

    this.setSelectedPricingView = this.setSelectedPricingView.bind(this);
    this.setSelectedSurveyView = this.setSelectedSurveyView.bind(this);
    this.setSelectedSlottedView = this.setSelectedSlottedView.bind(this);
    this.updateAgingFactor = this.updateAgingFactor.bind(this);
    this.switchTab = this.switchTab.bind(this);
    this.switchAddMatches = this.switchAddMatches.bind(this);
    this.handlePricingChange = this.handlePricingChange.bind(this);
    this.showSavePricingSlideout = this.showSavePricingSlideout.bind(this);
    this.onSave = this.onSave.bind(this);
    this.setDisplayIn = this.setDisplayIn.bind(this);
    this.setStatus = this.setStatus.bind(this);
    this.showYearOverYearSlideout = this.showYearOverYearSlideout.bind(this);
    this.showDifferentialsSlideout = this.showDifferentialsSlideout.bind(this);
    this.handleOnMatchSelect = this.handleOnMatchSelect.bind(this);
    this.togglePopover = this.togglePopover.bind(this);
    this.setReportDropdown = this.setReportDropdown.bind(this);
    this.resetReportDropdown = this.resetReportDropdown.bind(this);
    this.showSurveyDataCutsSlideout = this.showSurveyDataCutsSlideout.bind(this);
    this.getAuditTrailUrl = this.getAuditTrailUrl.bind(this);
    this.openSlottedJob = this.openSlottedJob.bind(this);
    this.updateModifiedDate = this.updateModifiedDate.bind(this);
    this.renderBenchmarkYearDropdown = this.renderBenchmarkYearDropdown.bind(this);
    this.renderAgingDropdown = this.renderAgingDropdown.bind(this);
    this.renderStatusDropdown = this.renderStatusDropdown.bind(this);
    this.toggleHeader = this.toggleHeader.bind(this);
    this.getSurveyJobDetailsPageHref = this.getSurveyJobDetailsPageHref.bind(this);
    this.getSlottedJobPageHref = this.getSlottedJobPageHref.bind(this);
    this.setSelectedBenchmarkYear = this.setSelectedBenchmarkYear.bind(this);
    this.getTabList = this.getTabList.bind(this);
    this.getPricingType = this.getPricingType.bind(this);
    this.isSlotted = this.isSlotted.bind(this);
    this.isPriced = this.isPriced.bind(this);
    this.setCurrency = this.setCurrency.bind(this);
    this.openCompSummary = this.openCompSummary.bind(this);
    this.getPricingDetailsForSlottedJob = this.getPricingDetailsForSlottedJob.bind(this);
    this.showUsedJobsModal = this.showUsedJobsModal.bind(this);
    this.getUsedModalJobs = this.getUsedModalJobs.bind(this);
    this.isEditPastYears = this.isEditPastYears.bind(this);
    this.showConfigureViewSlideout = this.showConfigureViewSlideout.bind(this);
    this.refreshViews = this.refreshViews.bind(this);
    this.getDefaultAgingCode = this.getDefaultAgingCode.bind(this);

    this.usedJobsModal = React.createRef();
  }

  componentDidMount() {
    const { actions, isAgingReducerLoaded, defaultBenchmarkYear, jobPricing } = this.props;

    actions.hideSlideout();
    actions.getConfigSettings();

    // will get both pricing and slotted details views
    this.refreshViews(PAGE_CODE.PRICING_DETAILS);

    // survey search views
    this.refreshViews(PAGE_CODE.SURVEY_SEARCH);

    // slotted search (job) views
    this.refreshViews(PAGE_CODE.SLOTTED_SEARCH);

    if (isAgingReducerLoaded) {
      const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear || defaultBenchmarkYear;
      this.setSelectedBenchmarkYear(benchmarkYear);
    }
  }

  componentWillUnmount() {
    const { actions, history, surveyLibraryFacetActions, surveyLibraryGridActions, jobPricingGridActions } = this.props;
    if (history.location.pathname.includes('compensation-summary-report')) {
      return;
    } else {
      actions.resetInternalJobsReducer();
      actions.resetJobPricingReducer();
      actions.resetOrgJobsLoading();
      jobPricingGridActions.resetJobPricingGrid();
      jobPricingGridActions.resetSubRows();
      surveyLibraryGridActions.reset();
      surveyLibraryFacetActions.resetSurveyLibraryReducer();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      actions,
      defaultBenchmarkYear,
      featureFlags,
      history,
      isAgingReducerLoaded,
      isLoadingOrgJob,
      isLoadingOrgJobFailed,
      jobPricing,
      jobPricingGridActions,
      marketPricing,
      masterAccountId,
      match
    } = this.props;
    const { MainJobPricingReducer, JobPricingGridReducer } = jobPricing;
    const { renderPopover } = this.state;
    const showAiMatching = featureFlags.find(flag => flag.name === 'showAiMatching')?.enabled;

    if (prevProps.match.params.tab !== match.params.tab) {
      if (renderPopover) this.togglePopover(0);
    }

    const isGetJobPricingLoaded = JobPricingGridReducer.loaded;

    const hasJobPricingFinishedLoading = !prevProps.jobPricing.JobPricingGridReducer.loaded && isGetJobPricingLoaded;
    const isSwitchingTabs =
      prevState.selectedTabIndex !== this.state.selectedTabIndex ||
      prevState.selectedAddMatchesIndex !== this.state.selectedAddMatchesIndex;

    if (hasJobPricingFinishedLoading || isSwitchingTabs) {
      const tabIndex = this.tabPaths.indexOf(this.props.match.params.tab);

      // Redirect if AI Matching is disabled
      if (history.location.pathname.endsWith('/ai-matching') && (!this.props.launchDarklyFeatureFlags['ai-matching'] || !showAiMatching)) {
        this.setState({ selectedAddMatchesIndex: SURVEY_LIBRARY_MATCHES }, () => {
          history.replace(`/market-analysis/jobs/${this.props.match.params.jobId}/survey-library`);
        });
        return;
      }

      if (this.isSlotted() && !this.isAdHocJob()) {
        if (tabIndex !== SLOTTED_PATH_INDEX && tabIndex !== SLOTTED_SEARCH_PATH_INDEX) {
          this.setState({ selectedTabIndex: DETAILS_TAB }, () => {
            history.push(`/market-analysis/jobs/${match.params.jobId}/slotted`);
          });
        }
      } else if (this.isPriced() && !this.isAdHocJob()) {
        if (tabIndex === SLOTTED_PATH_INDEX || tabIndex === SLOTTED_SEARCH_PATH_INDEX) {
          this.setState({ selectedTabIndex: DETAILS_TAB, selectedAddMatchesIndex: 0 }, () => {
            history.push(`/market-analysis/jobs/${match.params.jobId}/ai-matching`);
          });
        }
      }
    }

    const hasFailedToLoadOrgJob = prevProps.isLoadingOrgJob && !isLoadingOrgJob && isLoadingOrgJobFailed;

    if (hasFailedToLoadOrgJob) {
      history.push(NEW_MARKET_PRICING_URL);
    }

    // If selected aging factor changes
    if (isAgingReducerLoaded && isGetJobPricingLoaded && !MainJobPricingReducer.selectedAgingFactor) {
      this.setSelectedAgingFactor();
    }

    // If selected benchmark year changes
    if (isAgingReducerLoaded && !MainJobPricingReducer.selectedBenchmarkYear) {
      this.setSelectedBenchmarkYear(defaultBenchmarkYear);
    }

    // If the job's benchmark year is different
    const hasBenchmarkYearChanged =
      prevProps.jobPricing.MainJobPricingReducer.selectedBenchmarkYear !== MainJobPricingReducer.selectedBenchmarkYear;

    if (
      (!this.state.currentJob && MainJobPricingReducer.selectedBenchmarkYear) ||
      (this.state.currentJob && hasBenchmarkYearChanged) ||
      prevProps.match.params.jobId !== match.params.jobId
    ) {
      this.loadJob();
      //when switching years, if the new year is slotted, redraw the slot details section. MPE-8655
      if (this.isOnSlotPage()) {
        jobPricingGridActions.resetSubRows();
      }
    }

    // if changing the view on an adhoc job, don't recreate the adhoc job
    if (
      (MainJobPricingReducer.selectedViewPk !== prevProps.jobPricing.MainJobPricingReducer.selectedViewPk &&
        MainJobPricingReducer.selectedViewPk !== null) ||
      (MainJobPricingReducer.selectedViewSlottedPk !==
        prevProps.jobPricing.MainJobPricingReducer.selectedViewSlottedPk &&
        MainJobPricingReducer.selectedViewSlottedPk !== null)
    ) {
      if (this.isAdHocJob()) {
        this.handlePricingChange();
      } else {
        this.loadJob();
      }
    }

    const hasLoadedNewJob =
      (!prevState.currentJob && this.state.currentJob) || prevState.currentJob?.id !== this.state.currentJob?.id;
    const isDetailsTab = this.state.selectedTabIndex === DETAILS_TAB;

    if (hasLoadedNewJob && !isDetailsTab) {
      actions.getJobPricingDetails(
        this.state.currentJob,
        MainJobPricingReducer.selectedBenchmarkYear,
        marketPricing.displayIn,
        jobPricingGridActions.search,
        masterAccountId
      );
    }

    if (hasLoadedNewJob) {
      // Reset sub rows when switching jobs
      if (this.isOnSlotPage()) {
        jobPricingGridActions.resetSubRows();
      }
    }
  }

  getAddMatchesList(isAdhoc) {
    const showAiMatching = this.props.featureFlags.find(flag => flag.name === 'showAiMatching')?.enabled;
    if (isAdhoc) {
      return ['Survey Library Matches', 'Copy Matches', 'Marketplace Matches'];
    }
    if (this.props.launchDarklyFeatureFlags['ai-matching'] && showAiMatching) {
      return ['Survey Library Matches', 'AI Matching', 'Copy Matches', 'Marketplace Matches', 'Participation Matches'];
    } else {
      return ['Survey Library Matches', 'Copy Matches', 'Marketplace Matches', 'Participation Matches'];
    }
  }

  getPricingType() {
    return this.props.jobPricing.JobPricingGridReducer?.metadata?.pricingType;
  }

  isSlotted() {
    return this.getPricingType() === PRICING_TYPE.SLOTTED;
  }

  isPriced() {
    return this.getPricingType() === PRICING_TYPE.PRICED;
  }

  isOnSlotPage() {
    const tabIndex = this.tabPaths.indexOf(this.props.match.params.tab);

    return tabIndex === SLOTTED_PATH_INDEX || tabIndex === SLOTTED_SEARCH_PATH_INDEX;
  }

  getTabList() {
    if (this.isOnSlotPage()) {
      return ['Slotted Details', 'Add Slotted Job Matches'];
    }

    return ['Pricing Details', 'Add Matches'];
  }

  toggleHeader(pos) {
    const { showMinHeader } = this.state;
    const { scrollTop, className } = pos;

    if (className !== 'ps-popover') {
      if (scrollTop < MIN_HEADER_LIMIT / 2 && showMinHeader) {
        this.setState({ showMinHeader: false });
      } else if (scrollTop >= MIN_HEADER_LIMIT && !showMinHeader) {
        this.setState({ showMinHeader: true });
      }
    }
  }

  setCurrency(currency = '%') {
    return new Promise((resolve, reject) => {
      this.setState({ currency }, resolve);
    });
  }

  setSelectedAgingFactor() {
    const { actions, jobPricing } = this.props;

    const currentAgingCode = getCurrentAgingCode(jobPricing.JobPricingGridReducer);
    if (currentAgingCode) {
      actions.setSelectedAgingFactor(currentAgingCode);
    } else {
      const defaultAgingCode = this.getDefaultAgingCode(this.state.currency);

      actions.setSelectedAgingFactor(defaultAgingCode);
    }
  }

  // Find the default agingCode based on useCurrencyBasedAgingFactor (system config setting) and given currency
  getDefaultAgingCode(currency) {
    const { agingFactors } = this.props;
    let { useCurrencyBasedAgingFactor } = this.props;

    if (!agingFactors) return '';
    if (useCurrencyBasedAgingFactor == null) useCurrencyBasedAgingFactor = false;

    const defaultAging = agingFactors.find(a => a.isDefault === true);

    // If useCurrencyBasedAgingFactor = false
    //   - If no default agingCode found:
    //     - Return agingCode for given currency
    //     - If none found, return first agingCode in list
    //   - If default agingCode found, return it
    if (!useCurrencyBasedAgingFactor) {
      if (!defaultAging) {
        if (currency) {
          const currencyAgingFactor = agingFactors.find(a => a.currency === currency);

          return currencyAgingFactor?.agingCode || agingFactors[0]?.agingCode || '';
        } else {
          return agingFactors[0]?.agingCode || '';
        }
      }

      return defaultAging.agingCode;
    }

    // If useCurrencyBasedAgingFactor = true
    //   - If no currency given, return default agingCode
    //     - If no default found, return first agingCode in list
    //   - If currency given, find agingCode for given currency
    //     - If not found, return default agingCode
    //       - If default has a currency other than given currency, return any agingCode not tied to a currency
    //         - If none found, return default anyway
    if (useCurrencyBasedAgingFactor) {
      if (!currency) {
        return defaultAging?.agingCode || agingFactors[0]?.agingCode || '';
      } else {
        const currencyAgingFactor = agingFactors.find(a => a.currency === currency);

        if (currencyAgingFactor) {
          return currencyAgingFactor.agingCode;
        } else {
          if (defaultAging?.currency === currency) {
            return defaultAging?.agingCode;
          } else {
            return agingFactors.find(a => !a.currency)?.agingCode || defaultAging?.agingCode || '';
          }
        }
      }
    }

    // this should never happen, but return default aging code just in case
    return defaultAging?.agingCode;
  }

  switchTab = tab => {
    const { history, match } = this.props;
    const { selectedTabIndex, selectedAddMatchesIndex } = this.state;

    if (tab !== selectedTabIndex) {
      this.setState({ selectedTabIndex: tab, showMinHeader: false });

      let tabPath;
      if (tab === DETAILS_TAB) {
        tabPath = this.tabPaths[this.isOnSlotPage() ? SLOTTED_PATH_INDEX : PRICING_PATH_INDEX];
      } else {
        tabPath = this.tabPaths[this.isOnSlotPage() ? SLOTTED_SEARCH_PATH_INDEX : selectedAddMatchesIndex];
      }

      history.push(`/market-analysis/jobs/${match.params.jobId}/${tabPath}`);
    }
  };

  switchAddMatches = tab => {
    const { history, match } = this.props;
    const { selectedAddMatchesIndex } = this.state;

    const availableTabs = this.getAddMatchesList(this.isAdHocJob());
    
    let tabName = availableTabs[tab];

    const correctGlobalIndex = this.tabMapping[tabName];

    if (tabName && correctGlobalIndex !== selectedAddMatchesIndex) {

      this.setState({ selectedAddMatchesIndex: correctGlobalIndex, showMinHeader: false });

      let tabPath;

      if (tabName === 'Survey Library Matches') {
        tabPath = 'survey-library';
      } else if (tabName === 'Marketplace Matches') {
        tabPath = 'marketplace';
      } else {
        tabPath = this.tabPaths[this.tabPaths.indexOf(tabName.replace(' ', '-').toLowerCase())];
      }

      history.push(`/market-analysis/jobs/${match.params.jobId}/${tabPath}`);
    }
  };

  loadJob() {
    const {
      actions,
      currency,
      history,
      jobPricing,
      jobEmployeesLimit,
      jobEmployeesOffset,
      masterAccountId
    } = this.props;
    if (this.state.isLoadingJob) {
      return;
    }
    this.setState({ isLoadingJob: true }, () => {
      const jobId = this.getJobId();
      const isAdHocJob = this.isAdHocJob();
      if (isAdHocJob) {
        if (!this.state.currentJob) {
          actions.createAdHocJob().then(adHocJob => {
            const job = {
              id: adHocJob.orgJobId,
              code: adHocJob.orgJobCode,
              codeKey: adHocJob.orgJobCodeKey
            };
            this.setState({ isLoadingJob: false, currentJob: job });
            actions.getAgingFactors(currency.code);
          });
        } else {
          this.setState({ isLoadingJob: false });
        }
      } else {
        const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear;

        actions.getJobByID(jobId, !this.isOnSlotPage(), benchmarkYear).then(orgJob => {
          // make sure job is in the correct currency context
          if (currency && currency.code !== ALL_CURRENCIES_CODE && currency.code !== orgJob?.currency) {
            history.push(NEW_MARKET_PRICING_URL);
          }
          this.setState({ isLoadingJob: false, currentJob: orgJob, currency: orgJob?.currency });
          actions.getAgingFactors(currency.code, benchmarkYear);
          actions.getLastModifiedDate(jobId, benchmarkYear);
          actions.downloadJobDescription(orgJob);
          this.setSelectedAgingFactor();

          actions.getEmployeeSelectedView().then(resp => {
            if (orgJob) {
              const options = {
                limit: jobEmployeesLimit,
                offset: jobEmployeesOffset,
                jobCode: orgJob.code,
                jobCodeKey: orgJob.codeKey,
                viewPk: resp
              };

              actions.getJobEmployees(options);
            }
          });

          actions.getJobDetailsSelectedView(masterAccountId);
        });
      }
    });
  }

  openCompSummary() {
    const { history, actions, jobPricing, selectedEmployeesViewPk, selectedJobDetailsViewPk } = this.props;
    const { currentJob } = this.state;

    actions.setBenchmarkYearCSR(jobPricing.MainJobPricingReducer.selectedBenchmarkYear);

    history.push(`/market-analysis/jobs/${currentJob.id}/pricing/compensation-summary-report`, {
      modal: true,
      modalType: 'COMPENSATION_SUMMARY_REPORT',
      modalProps: {
        className: 'comp-sum__modal',
        orgJob: currentJob,
        selectedEmployeesViewPk,
        selectedJobDetailsViewPk
      },
      component: 'COMPENSATION_SUMMARY_REPORT'
    });
  }

  isAdHocJob() {
    return isAdHocJobId(this.getJobId());
  }

  togglePopover(event, id) {
    event?.stopPropagation();
    const { renderPopover } = this.state;
    this.setState({ renderPopover: !renderPopover, selectedRowId: id });
  }

  updateModifiedDate(jobId, benchmarkYear) {
    if (!isAdHocJobId(jobId) && benchmarkYear) {
      this.props.actions.getLastModifiedDate(jobId, benchmarkYear);
    }
  }

  showUsedJobsModal() {
    this.usedJobsModal?.current?.show();
  }

  getUsedModalJobs() {
    return (
      this.state.usedJobs?.map(job => {
        return (
          <div className="used-jobs__list-item">
            <a className="used-jobs__link" href={`../../jobs/${job.org_job_id}/slotted`} target="_blank">
              {job.org_job_title}
              {job.org_job_code && ` - ${job.org_job_code}`}
              {job.org_job_code_key && job.org_job_code_key !== ' ' && `, ${job.org_job_code_key}`}
            </a>
          </div>
        );
      }) || []
    );
  }

  getAuditTrailUrl() {
    const { jobPricing, organizationCode } = this.props;
    const { currentJob } = this.state;
    const jobCodeParam = `org_job_code=${currentJob?.code}`;
    const jobCodeKeyParam = `org_job_code_key=${currentJob?.codeKey}`;
    const surveyYearParam = `search_survey_year=${jobPricing?.MainJobPricingReducer?.selectedBenchmarkYear}`;
    const baseUrl = `${window.location.origin}/view/o/${organizationCode}/mp/iframe/merit/merit-admin/audit`;
    return `${baseUrl}?${jobCodeParam}&${jobCodeKeyParam}&${surveyYearParam}`;
  }

  renderAboutJobDropdown() {
    const {
      readOnlyUser,
      marketPricing,
      history,
      hasHRTMSIntegration,
      launchDarklyFeatureFlags,
      jobEmployeesData
    } = this.props;
    const { currentJob, isLoadingJob } = this.state;
    const totalEmployees = jobEmployeesData?.metadata?.totalCount;
    const employeeLabel = `View Employees (${totalEmployees})`;
    const isAdHocJob = this.isAdHocJob();
    const jobLabel = isAdHocJob ? 'Save Job' : 'Edit Job';
    const jobDetailsLabel = 'View Job Details';
    const openSideBySideJdx = jdxTitles.SIDE_BY_SIDE;
    const isJDXEnabled = hasHRTMSIntegration;
    const hasJobDescription = marketPricing?.jobDescription?.downloadURL;

    let descriptionAction = 'Add';
    if (hasJobDescription) {
      descriptionAction = 'View';
    } else if (isJDXEnabled) {
      descriptionAction = 'Create';
    }

    const descriptionLabel = `${descriptionAction} Job Description`;
    let options = [jobLabel];
    if (isJDXEnabled) options.push(openSideBySideJdx);
    if (!isAdHocJob) options.unshift(descriptionLabel, jobDetailsLabel);
    options.push(employeeLabel);

    const disabledOptions = [];
    if (totalEmployees === 0) disabledOptions.push(employeeLabel);

    if (isAdHocJob && readOnlyUser) {
      return null;
    }

    if (isAdHocJob) {
      const saveButtonClassName = classnames('pricing-button__save', 'pxl-btn', {
        'pxl-btn-default': !isAdHocJob,
        'pxl-btn-primary': isAdHocJob
      });

      return (
        <a className={saveButtonClassName} onClick={this.showSavePricingSlideout}>
          {jobLabel}
        </a>
      );
    }

    return (
      <Dropdown
        className="market-pricing__about-dropdown"
        text="About This Job"
        disabled={isLoadingJob}
        dropdownItems={Object.values(options)}
        disabledOptions={disabledOptions}
        itemOnClick={value => {
          const backToRoute = `/market-analysis/jobs/${this.state.currentJob.id}/pricing`;

          if (value === descriptionLabel) {
            const { currentJob } = this.state;

            if (isJDXEnabled && !hasJobDescription) {
              history.push(backToRoute + '/add-job-description', {
                modal: true,
                modalType: 'JDX_IFRAME',
                modalProps: {
                  backToRoute,
                  className: 'jdexpert__modal',
                  jdxAction: jdxActions.ADD_JOB_DESCRIPTION,
                  titleText: `JDXpert - ${currentJob.title}`,
                  backToText: 'Market Pricing',
                  currentJob,
                  hideClose: true,
                  launchDarklyFeatureFlags
                },
                component: 'JDX_IFRAME'
              });
            } else {
              this.props.actions.showSlideout(MP_SLIDEOUTS.JOB_DESCRIPTION_SLIDEOUT, {
                backToRoute,
                orgJobId: currentJob?.id,
                orgJobCode: currentJob?.code,
                orgJobCodeKey: currentJob?.codeKey,
                orgJobTitle: currentJob?.title,
                launchDarklyFeatureFlags
              });
            }
          } else if (value === jobLabel) {
            this.showSavePricingSlideout();
          } else if (value === openSideBySideJdx) {
            history.push(backToRoute + '/jdxpert', {
              modal: true,
              modalType: 'JDX_IFRAME',
              modalProps: {
                backToRoute,
                className: 'jdexpert__modal',
                jdxAction: jdxActions.SIDE_BY_SIDE,
                titleText: openSideBySideJdx,
                backToText: 'Market Pricing',
                currentJob,
                hideClose: true,
                launchDarklyFeatureFlags
              },
              component: 'JDX_IFRAME'
            });
          } else if (value === employeeLabel && !isAdHocJob && totalEmployees > 0) {
            this.props.actions.showSlideout(MP_SLIDEOUTS.JOB_EMPLOYEES, {
              jobCode: currentJob?.code,
              jobCodeKey: currentJob?.codeKey
            });
          } else if (value === jobDetailsLabel) {
            this.props.actions.showSlideout(MP_SLIDEOUTS.JOB_DETAILS, {
              jobCode: currentJob?.code,
              jobCodeKey: currentJob?.codeKey
            });
          }
        }}
      />
    );
  }

  showYearOverYearSlideout() {
    const { jobPricing, defaultBenchmarkYear, actions, marketPricing } = this.props;
    const { currentJob } = this.state;
    const { id, code, codeKey } = currentJob;
    const displayIn = marketPricing.displayIn;
    const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear || defaultBenchmarkYear;

    actions.getHeaderInfo(id).then(() => {
      actions.getOverallComposite(code, codeKey, benchmarkYear, displayIn);
      actions.setYearOverYearDisplayIn(displayIn);
      actions.showSlideout(MP_SLIDEOUTS.YEAR_OVER_YEAR);
    });
  }

  showDifferentialsSlideout() {
    const { actions, jobPricing, defaultBenchmarkYear, marketPricing } = this.props;
    const { currentJob, currency } = this.state;
    const orgJobId = currentJob.id;
    const orgJobCode = currentJob.code;
    const orgJobCodeKey = currentJob.codeKey;
    const jobTitle = currentJob.title;
    const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear || defaultBenchmarkYear;
    const displayIn = marketPricing.displayIn;

    actions.showSlideout(MP_SLIDEOUTS.SKILL_GEO_DIFFERENTIAL, {
      orgJobId,
      orgJobCode,
      orgJobCodeKey,
      currency,
      jobTitle,
      benchmarkYear,
      displayIn,
      refreshJobTabData: this.handlePricingChange
    });
  }

  handleOnMatchSelect(selectedMatchCurrency, isRemove) {
    const { jobPricing, slottedSearchActions } = this.props;
    const selectedSurveys = jobPricing.MainJobPricingReducer.selectedCutIDs;
    const selectedSlottedJobs = jobPricing.MainJobPricingReducer.selectedSlottedJobs;
    const selectedAgingFactor = jobPricing.MainJobPricingReducer.selectedAgingFactor;

    const defaultNoCurrencyAgingCode = this.getDefaultAgingCode();
    const currentDefaultAgingCode = this.getDefaultAgingCode(selectedMatchCurrency);

    let agingFactorToUse = defaultNoCurrencyAgingCode;
    if (currentDefaultAgingCode !== defaultNoCurrencyAgingCode) {
      agingFactorToUse = currentDefaultAgingCode;
    }

    if (selectedAgingFactor !== defaultNoCurrencyAgingCode && selectedAgingFactor !== currentDefaultAgingCode) {
      agingFactorToUse = selectedAgingFactor;
    }

    // If removing the last match on adhoc, use default agingCode
    if (!this.isOnSlotPage() && isRemove && selectedSurveys.length === 0 && this.isAdHocJob()) {
      agingFactorToUse = defaultNoCurrencyAgingCode;
      this.updateAgingFactor(agingFactorToUse, undefined);
    } else {
      this.updateAgingFactor(agingFactorToUse, selectedMatchCurrency || this.state.currency);
    }

    if (this.isAdHocJob()) {
      if (this.isOnSlotPage()) {
        slottedSearchActions.setSlottedCurrency(
          isRemove && selectedSlottedJobs.length === 0 ? '%' : selectedMatchCurrency
        );
      } else {
        this.setCurrency(isRemove && selectedSurveys.length === 0 ? null : selectedMatchCurrency);
      }
    }

    if (
      (this.isOnSlotPage() && selectedSlottedJobs?.length !== 0) ||
      (!this.isOnSlotPage() && selectedSurveys?.length !== 0)
    ) {
      if (selectedMatchCurrency && selectedMatchCurrency !== this.state.currency) {
        this.setState({ currency: selectedMatchCurrency });
      }
    }
  }

  renderStatusDropdown() {
    const { jobPricing } = this.props;

    const statusItems = Object.values(PRICING_TYPE);
    const selectedSurveys = jobPricing.MainJobPricingReducer.selectedCutIDs;
    const selectedSlottedJobs = jobPricing.MainJobPricingReducer.selectedSlottedJobs;
    const jobsLength = this.isOnSlotPage() ? selectedSlottedJobs.length : selectedSurveys.length;
    const staticAdhocLabel = this.isAdHocJob() && jobsLength > 0;

    const label = this.isAdHocJob()
      ? this.isOnSlotPage()
        ? PRICING_TYPE.SLOTTED
        : PRICING_TYPE.PRICED
      : this.getPricingType() || 'Neither';

    if (this.isReadOnly() || staticAdhocLabel) {
      return (
        <div className="dropdown-group">
          <label>Status</label>
          <div className="status-read-only">{capitalizeFirstLetter(label)}</div>
        </div>
      );
    }

    if (this.props.isLoadingOrgJob) {
      return <span className="dropdown-loading"></span>;
    }

    return (
      <div className="dropdown-group">
        <label>Status</label>
        <Dropdown
          className="pricing-dropdown capitalize"
          text={capitalizeFirstLetter(label)}
          dropdownItems={statusItems}
          itemOnClick={selectedType => this.setStatus(this.getPricingType(), selectedType)}
        />
      </div>
    );
  }

  renderDisplayDropdown() {
    const { marketPricing, isLoadingOrgJob } = this.props;

    if (isLoadingOrgJob) {
      return <span className="dropdown-loading"></span>;
    }

    return (
      <div className="dropdown-group">
        <label>Display</label>
        <Dropdown
          className="pricing-dropdown capitalize"
          text={marketPricing.displayIn}
          dropdownItems={Object.values(DISPLAY_IN_TYPE)}
          itemOnClick={this.setDisplayIn}
        />
      </div>
    );
  }

  renderAgingDropdown() {
    const { isAgingFactorsLoaded, jobPricing } = this.props;

    if (this.isOnSlotPage()) return null;

    if (isAgingFactorsLoaded && jobPricing.MainJobPricingReducer.selectedAgingFactor) {
      return (
        <div className="dropdown-group">
          <label>Aging</label>
          <Dropdown
            className="pricing-dropdown"
            text={jobPricing.MainJobPricingReducer.selectedAgingFactor}
            dropdownItems={this.getAgingDropdownItems()}
            itemOnClick={agingFactor => this.updateAgingFactor(agingFactor, this.state.currency)}
            disabled={this.isReadOnly()}
          />
        </div>
      );
    } else {
      return <span className="dropdown-loading"></span>;
    }
  }

  refreshViews(pageCode) {
    const { actions, slottedSearchActions, masterAccountId: maid } = this.props;

    if (pageCode === PAGE_CODE.PRICING_DETAILS || pageCode === PAGE_CODE.SLOTTED_DETAILS) {
      // pricing and slotted views, must be done together so the views stay in-sync
      actions.getPricingViews(maid, false).then(actions.getSelectedPricingView(maid, false));
      actions.getPricingViews(maid, true).then(actions.getSelectedPricingView(maid, true));
    } else if (pageCode === PAGE_CODE.SURVEY_SEARCH) {
      // survey search views
      actions.getSurveyViews(maid).then(actions.getSelectedSurveyView(maid));
    } else if (pageCode === PAGE_CODE.SLOTTED_SEARCH) {
      // slotted search views
      slottedSearchActions.getSlottedSearchViews(maid).then(slottedSearchActions.getSlottedSearchSelectedView(maid));
    }
  }

  showConfigureViewSlideout(page, pageCode, pageName, categoryCode, overrideCategoryCode) {
    this.props.actions.showSlideout(MP_SLIDEOUTS.CONFIGURE_VIEW, {
      onRefresh: () => this.refreshViews(pageCode),
      categoryCode,
      overrideCategoryCode,
      page,
      pageCode,
      pageName,
      onRefreshData: this.handlePricingChange,
      includeAggregates: false
    });
  }

  renderSlottedViewDropdown() {
    const slottedSearch = this.props.slottedSearch.slottedSearchReducer;
    const slottedGridView = this.props.slottedSearch.slottedSearchGridReducer?.metadata?.viewName || '';
    const viewText = this.getSelectedSlottedViewName(slottedSearch.slottedSearchSelectedView?.selectedViewPk);

    if (this.props.isLoadingOrgJob) {
      return <span className="dropdown-loading"></span>;
    }

    if (slottedSearch.slottedSearchViews?.views) {
      return (
        <div className="dropdown-group">
          <label>Job View</label>
          <Dropdown
            className="pricing-dropdown"
            text={viewText || slottedGridView}
            customRenderComponent={DropdownViews}
            customRenderProps={{
              views: slottedSearch.slottedSearchViews?.views,
              selectedViewPk: slottedSearch.slottedSearchSelectedView?.selectedViewPk,
              userRights: this.props.userRights,
              groupAdminCanConfigureViews: this.props.groupAdminCanConfigureViews,
              regularUserCanConfigureViews: this.props.regularUserCanConfigureViews,
              onEdit: () =>
                this.showConfigureViewSlideout(
                  PAGE.SLOTTED_SEARCH,
                  PAGE_CODE.SLOTTED_SEARCH,
                  'Job Views',
                  CATEGORY_CODE.SLOTTED_SEARCH
                ),
              onSelectView: this.setSelectedSlottedView
            }}
          />
        </div>
      );
    }
  }

  renderPricingViewDropdown() {
    const { jobPricing } = this.props;

    if (jobPricing.MainJobPricingReducer.pricingViews?.length > 0) {
      const pricingGridView = jobPricing.JobPricingGridReducer?.metadata?.viewName || '';
      const viewText = this.getSelectedPricingViewName(jobPricing.MainJobPricingReducer.selectedViewPk);

      if (!viewText && !pricingGridView) {
        return <div className="dropdown-loading"></div>;
      }

      return (
        <div className="dropdown-group">
          <label>Pricing View</label>
          <Dropdown
            className="pricing-dropdown"
            text={viewText || pricingGridView}
            customRenderComponent={DropdownViews}
            customRenderProps={{
              views: jobPricing.MainJobPricingReducer.pricingViews,
              selectedViewPk: jobPricing.MainJobPricingReducer.selectedViewPk,
              userRights: this.props.userRights,
              groupAdminCanConfigureViews: this.props.groupAdminCanConfigureViews,
              regularUserCanConfigureViews: this.props.regularUserCanConfigureViews,
              onEdit: () =>
                this.showConfigureViewSlideout(
                  PAGE.PRICING_DETAILS,
                  PAGE_CODE.PRICING_DETAILS,
                  'Pricing Views',
                  CATEGORY_CODE.PRICING_DETAILS
                ),
              onSelectView: newView => {
                if (newView !== viewText) this.props.jobMatchGridActions.setIsStale('all', true);
                this.setSelectedPricingView(newView);
              }
            }}
          />
        </div>
      );
    } else {
      return <div className="dropdown-loading"></div>;
    }
  }

  renderPricingViewSlottedDropdown() {
    const { jobPricing } = this.props;

    if (jobPricing.MainJobPricingReducer.slottedViews?.length > 0) {
      const pricingGridView = jobPricing.JobPricingGridReducer?.metadata?.viewName || '';
      const viewText = this.getSelectedPricingViewNameSlotted(jobPricing.MainJobPricingReducer.selectedViewSlottedPk);

      if (!viewText && !pricingGridView) {
        return <div className="dropdown-loading"></div>;
      }

      return (
        <div className="dropdown-group">
          <label>Slotted View</label>
          <Dropdown
            className="pricing-dropdown"
            text={viewText || pricingGridView}
            customRenderComponent={DropdownViews}
            customRenderProps={{
              views: jobPricing.MainJobPricingReducer.slottedViews,
              selectedViewPk: jobPricing.MainJobPricingReducer.selectedViewSlottedPk,
              userRights: this.props.userRights,
              groupAdminCanConfigureViews: this.props.groupAdminCanConfigureViews,
              regularUserCanConfigureViews: this.props.regularUserCanConfigureViews,
              onEdit: () =>
                this.showConfigureViewSlideout(
                  PAGE.SLOTTED_DETAILS,
                  PAGE_CODE.SLOTTED_DETAILS,
                  'Slotted Views',
                  CATEGORY_CODE.SLOTTED_DETAILS,
                  CATEGORY_CODE.PRICING_DETAILS // override category, to make elements match between pricing and slotted details
                ),
              onSelectView: newView => {
                if (newView !== viewText) this.props.jobMatchGridActions.setIsStale('all', true);
                this.setSelectedPricingView(newView);
              }
            }}
          />
        </div>
      );
    }
  }

  renderSurveyViewDropdown() {
    const {
      marketPricing,
      isLoadingOrgJob,
      surveyLibrary,
      internalJobs,
      marketplaceMatches,
      participationMatches
    } = this.props;
    const surveyGridView =
      surveyLibrary.SurveyLibraryGridReducer?.metadata?.viewName ||
      internalJobs.InternalJobsGridReducer?.metadata?.viewName ||
      marketplaceMatches.marketplaceMatchesGridReducer?.metadata?.viewName ||
      participationMatches.participationMatchesGridReducer?.metadata?.viewName ||
      '';

    if (isLoadingOrgJob) {
      return <span className="dropdown-loading"></span>;
    }

    if (marketPricing.surveyViews?.views) {
      return (
        <div className="dropdown-group">
          <label>Survey View</label>
          <Dropdown
            className="pricing-dropdown"
            text={this.getSelectedSurveyViewName(marketPricing.surveySelectedView?.selectedViewPk) || surveyGridView}
            customRenderComponent={DropdownViews}
            customRenderProps={{
              views: marketPricing.surveyViews?.views,
              selectedViewPk: marketPricing.surveySelectedView?.selectedViewPk,
              userRights: this.props.userRights,
              groupAdminCanConfigureViews: this.props.groupAdminCanConfigureViews,
              regularUserCanConfigureViews: this.props.regularUserCanConfigureViews,
              onEdit: () =>
                this.showConfigureViewSlideout(
                  PAGE.SURVEY_SEARCH,
                  PAGE_CODE.SURVEY_SEARCH,
                  'Survey Views',
                  CATEGORY_CODE.SURVEY_SEARCH
                ),
              onSelectView: this.setSelectedSurveyView
            }}
          />
        </div>
      );
    }
  }

  renderBenchmarkYearDropdown() {
    const { isAgingReducerLoaded, jobPricing, benchmarkYears } = this.props;

    if (isAgingReducerLoaded) {
      return (
        <div className="dropdown-group">
          <label>Bmk Year</label>
          <Dropdown
            className="pricing-dropdown"
            text={jobPricing.MainJobPricingReducer.selectedBenchmarkYear}
            leftBound={true}
            dropdownItems={benchmarkYears}
            itemOnClick={this.setSelectedBenchmarkYear}
            disabled={this.isAdHocJob()}
          />
        </div>
      );
    }
  }

  setSelectedBenchmarkYear(benchmarkYear) {
    const { actions } = this.props;
    const { currentJob } = this.state;
    if (currentJob) actions.getRangeChartData(currentJob.code, currentJob.codeKey, benchmarkYear);
    actions.setSelectedBenchmarkYear(benchmarkYear);
  }

  renderGenerateReportDropdown() {
    const { isLoadingOrgJob } = this.props;
    const dropdownOptions = ['Compensation Summary'];

    if (isLoadingOrgJob) {
      return <span className="dropdown-loading"></span>;
    }

    return (
      <div className="dropdown-group">
        <Dropdown
          className="report-dropdown"
          text="Generate Report"
          dropdownItems={dropdownOptions}
          itemOnClick={this.setReportDropdown}
        />
      </div>
    );
  }

  renderDropdowns() {
    const { selectedTabIndex } = this.state;

    return (
      <React.Fragment>
        {this.renderGenerateReportDropdown()}
        {this.renderStatusDropdown()}
        {this.renderDisplayDropdown()}
        {selectedTabIndex === DETAILS_TAB && !this.isOnSlotPage() && this.renderPricingViewDropdown()}
        {selectedTabIndex === DETAILS_TAB && this.isOnSlotPage() && this.renderPricingViewSlottedDropdown()}
        {selectedTabIndex !== DETAILS_TAB && !this.isOnSlotPage() && this.renderSurveyViewDropdown()}
        {selectedTabIndex !== DETAILS_TAB && this.isOnSlotPage() && this.renderSlottedViewDropdown()}
      </React.Fragment>
    );
  }

  getAgingFactors() {
    const { agingFactors, currency: siteCurrency } = this.props;
    const selectedSurveys = this.props.jobPricing.MainJobPricingReducer.selectedCutIDs;
    const { currency } = this.state;
    const isAdhocJob = this.isAdHocJob();
    const noMatchesSelected = !selectedSurveys || selectedSurveys.length === 0;
    // keep default (regardless of its currency) as an option if aging factors have currencies attached
    // and none match the current job's currency
    const hasMatchingAgingFactorCurrency = !!agingFactors.find(factor => factor.currency === currency);

    return agingFactors.filter(factor => {
      if (!isAdhocJob || (isAdhocJob && !noMatchesSelected)) {
        if (!hasMatchingAgingFactorCurrency && factor.isDefault) {
          return true;
        }

        return factor.currency === currency || factor.currency === null;
      }

      return siteCurrency.code === '%' ? true : factor.currency === siteCurrency.code;
    });
  }

  getAgingDropdownItems() {
    return this.getAgingFactors().map(factor => factor.agingCode);
  }

  setReportDropdown(option) {
    const { actions } = this.props;
    if (option === 'Compensation Summary') this.openCompSummary();
    actions.setReportDropdown(option);
  }

  resetReportDropdown() {
    const { actions } = this.props;
    actions.resetReportDropdown();
  }

  setDisplayIn(displayIn) {
    const { jobPricing, actions, masterAccountId, jobPricingGridActions, currency } = this.props;
    const { MainJobPricingReducer } = jobPricing;
    const { currentJob } = this.state;

    if (currentJob) {
      actions.getRangeChartData(currentJob.code, currentJob.codeKey, MainJobPricingReducer.selectedBenchmarkYear);
      actions.setDisplayIn(displayIn.toLowerCase());
      actions.setDisplayInCSR(displayIn.toLowerCase());

      if (this.isOnSlotPage()) {
        const surveysForSlottedMatches = jobPricing.JobPricingGridReducer.surveysForSlottedMatches;
        const slottedExpandedSections = jobPricing.JobPricingGridReducer.slottedExpandedSections;
        const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear;
        const slottedJobs = jobPricing.JobPricingGridReducer;
        const selectedSlottedViewName = this.getSelectedPricingViewNameSlotted(
          jobPricing.MainJobPricingReducer.selectedViewSlottedPk,
          true
        );

        jobPricingGridActions.refreshSlottedSubRows(
          benchmarkYear,
          displayIn.toLowerCase(),
          masterAccountId,
          currency?.code,
          surveysForSlottedMatches,
          slottedJobs,
          jobPricingGridActions.getSurveysForSlotted,
          slottedExpandedSections,
          selectedSlottedViewName
        );
      }
    }
  }

  setStatus(pricingType, selectedType) {
    const pricingTypeLower = pricingType?.toLowerCase();
    const selectedTypeLower = selectedType?.toLowerCase();

    // If current pricing type is 'neither', then switch pages, but don't set slot_p
    // since a merit_match_summary doesn't exist yet
    if (!pricingTypeLower || pricingTypeLower === 'neither' || this.isAdHocJob()) {
      const { history } = this.props;

      if (selectedTypeLower === PRICING_TYPE.SLOTTED.toLowerCase()) {
        this.setState({ selectedTabIndex: SEARCH_TAB }, () => {
          history.push(`/market-analysis/jobs/${this.isAdHocJob() ? 'adhoc' : this.getJobId()}/slotted`);
        });
      } else if (selectedTypeLower === PRICING_TYPE.PRICED.toLowerCase()) {
        this.setState({ selectedTabIndex: SEARCH_TAB }, () => {
          history.push(`/market-analysis/jobs/${this.isAdHocJob() ? 'adhoc' : this.getJobId()}/pricing`);
        });
      }
    } else if (pricingTypeLower !== selectedTypeLower) {
      const { actions, jobPricing, jobPricingGridActions } = this.props;
      const { MainJobPricingReducer } = jobPricing;
      const { currentJob } = this.state;

      const benchmarkYear = MainJobPricingReducer.selectedBenchmarkYear;

      actions.changeStatus(selectedTypeLower, currentJob, benchmarkYear).then(usedJobs => {
        if (usedJobs) {
          this.setState({ usedJobs });
          this.showUsedJobsModal();
        } else {
          this.handlePricingChange();
          jobPricingGridActions.resetSubRows();
        }
      });
    }
  }

  getJobId() {
    const { match } = this.props;
    const jobId = match?.params?.jobId === 'adhoc' ? 0 : match.params.jobId;
    return isNaN(jobId) ? null : jobId;
  }

  setSelectedPricingView(view) {
    const { jobPricing, actions, masterAccountId, jobPricingGridActions, marketPricing, currency } = this.props;
    const isSlotted = this.isSlotted();

    const views = isSlotted
      ? jobPricing.MainJobPricingReducer?.slottedViews
      : jobPricing.MainJobPricingReducer?.pricingViews;
    const selectedView = views?.find(p => p.view_name === view);

    if (selectedView) {
      actions.setSelectedPricingView(selectedView.view_pk, masterAccountId, this.isSlotted()).then(() => {
        // After changing views, if on slot page, reload all expanded sub rows with new data for new view
        if (this.isOnSlotPage()) {
          const surveysForSlottedMatches = jobPricing.JobPricingGridReducer.surveysForSlottedMatches;
          const slottedExpandedSections = jobPricing.JobPricingGridReducer.slottedExpandedSections;
          const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear;
          const slottedJobs = jobPricing.JobPricingGridReducer;
          const selectedSlottedViewName = this.getSelectedPricingViewNameSlotted(selectedView.view_pk, true);

          jobPricingGridActions.refreshSlottedSubRows(
            benchmarkYear,
            marketPricing.displayIn,
            masterAccountId,
            currency?.code,
            surveysForSlottedMatches,
            slottedJobs,
            jobPricingGridActions.getSurveysForSlotted,
            slottedExpandedSections,
            selectedSlottedViewName
          );
        }
      });
    }
  }

  setSelectedSurveyView(view) {
    const { marketPricing, actions, masterAccountId } = this.props;

    const selectedSurveyView = marketPricing.surveyViews?.views?.find(surveyView => surveyView.view_name === view);

    if (selectedSurveyView) {
      actions.setSelectedSurveyView(selectedSurveyView.view_pk, masterAccountId);
    }
  }

  setSelectedSlottedView(view) {
    const { slottedSearchActions, masterAccountId } = this.props;
    const slottedSearch = this.props.slottedSearch.slottedSearchReducer;

    const selectedSlottedView = slottedSearch.slottedSearchViews?.views?.find(
      slottedView => slottedView.view_name === view
    );

    if (selectedSlottedView) {
      slottedSearchActions.setSlottedSearchSelectedView(selectedSlottedView.view_pk, masterAccountId);
    }
  }

  getSelectedPricingViewName(viewPk) {
    const { jobPricing } = this.props;

    const metadataViewName = jobPricing.JobPricingGridReducer?.metadata?.viewName;
    const pricingView = jobPricing.MainJobPricingReducer.pricingViews?.find(view => view.view_pk === viewPk);

    return metadataViewName || pricingView?.view_name || null;
  }

  getSelectedPricingViewNameSlotted(viewPk, ignoreMetadata = false) {
    const { jobPricing } = this.props;

    const metadataViewName = jobPricing.JobPricingGridReducer?.metadata?.viewName;
    const view = jobPricing.MainJobPricingReducer.slottedViews?.find(view => view.view_pk === viewPk);

    return !ignoreMetadata ? metadataViewName || view?.view_name || null : view?.view_name || null;
  }

  getSelectedSurveyViewName(viewPk) {
    const { marketPricing } = this.props;

    const surveyView = marketPricing.surveyViews?.views?.find(view => view.view_pk === viewPk);

    return surveyView?.view_name || null;
  }

  getSelectedSlottedViewName(viewPk) {
    const slottedSearch = this.props.slottedSearch.slottedSearchReducer;

    const slottedView = slottedSearch.slottedSearchViews?.views?.find(view => view.view_pk === viewPk);
    return slottedView?.view_name || null;
  }

  updateAgingFactor(newAgingFactor, currency) {
    const { actions, jobPricing, defaultBenchmarkYear } = this.props;
    const { currentJob } = this.state;
    const { MainJobPricingReducer } = jobPricing;

    if (newAgingFactor === MainJobPricingReducer.selectedAgingFactor) {
      return;
    }

    const jobId = this.getJobId();
    const benchmarkYear = MainJobPricingReducer.selectedBenchmarkYear;
    const isPastYear = benchmarkYear < defaultBenchmarkYear;
    const editPastYears = this.isEditPastYears();

    if (!isPastYear || (isPastYear && editPastYears)) {
      actions.updateAgingFactor(jobId, newAgingFactor, benchmarkYear, currency).then(() => {
        this.updateModifiedDate(jobId, benchmarkYear);
        if (currentJob) actions.getRangeChartData(currentJob.code, currentJob.codeKey, benchmarkYear);

        this.handlePricingChange();
      });
    }
  }

  showSavePricingSlideout() {
    const { actions, agingFactors, jobPricing, marketPricing } = this.props;
    const isGetJobPricingFailed = !!jobPricing.JobPricingGridReducer.error;
    if (isGetJobPricingFailed) {
      return;
    }
    const agingFactor = agingFactors.find(
      factor => factor.agingCode === jobPricing.MainJobPricingReducer.selectedAgingFactor
    );
    let currency = this.state.currency;

    if (this.isAdHocJob()) {
      const jobPricingGrid = jobPricing.JobPricingGridReducer;
      const currencyIndex = getColumnIndex(jobPricingGrid, 'currency_default');

      if (jobPricingGrid?.data?.length > 0) {
        currency = jobPricingGrid.data[0][currencyIndex];
      }
    }

    if (this.isAdHocJob()) {
      this.handlePricingChange();
    }

    actions.showSlideout(MP_SLIDEOUTS.SAVE_JOB_PRICING, {
      agingCode: agingFactor?.agingCode,
      defaultCurrency: currency,
      currentJob: this.state.currentJob,
      onSave: this.onSave,
      isReadOnly: this.isReadOnly(),
      isSlotted: this.isOnSlotPage(),
      displayIn: marketPricing.displayIn
    });
  }

  onSave(jobId, isSlotted, showGroupFilterMessage) {
    const { history, actions, jobPricing } = this.props;
    const { JobPricingGridReducer: jobPricingGrid } = jobPricing;

    if (showGroupFilterMessage) {
      history.push(`/market-analysis/market-pricing`);
    } else if (this.isAdHocJob() && jobId) {
      const benchmarkCommentIndex = getColumnIndex(jobPricingGrid, 'benchmark_comment_default');
      const benchmarkAdjIndex = getColumnIndex(jobPricingGrid, 'benchmark_adjustment_default');
      const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear;

      const benchmarkComment =
        (benchmarkCommentIndex === -1 && jobPricingGrid.data.length > 0) || !jobPricingGrid.data[0]
          ? undefined
          : jobPricingGrid.data[0][benchmarkCommentIndex];
      const benchmarkAdjustment =
        (benchmarkAdjIndex === -1 && jobPricingGrid.data.length > 0) || !jobPricingGrid.data[0]
          ? undefined
          : jobPricingGrid.data[0][benchmarkAdjIndex];

      actions.updateMeritMatchSummaries(jobId, benchmarkAdjustment, benchmarkComment, benchmarkYear).then(() => {
        if (this.isSlotted()) {
          history.push(`/market-analysis/jobs/${jobId}/slotted`);
        } else {
          history.push(`/market-analysis/jobs/${jobId}/pricing`);
        }
      });
    } else {
      this.loadJob();
    }
  }

  handlePricingChange() {
    const { actions, jobPricing, marketPricing, jobPricingGridActions, masterAccountId } = this.props;
    const { currentJob } = this.state;

    if (currentJob) {
      this.updateModifiedDate(currentJob.id, jobPricing.MainJobPricingReducer.selectedBenchmarkYear);

      return actions.getJobPricingDetails(
        currentJob,
        jobPricing.MainJobPricingReducer.selectedBenchmarkYear,
        marketPricing.displayIn,
        jobPricingGridActions.search,
        masterAccountId
      );
    }
  }

  getPricingDetailsForSlottedJob(slottedJob) {
    const { currency, jobPricing, marketPricing, jobPricingGridActions, masterAccountId } = this.props;
    const selectedSlottedViewName = this.getSelectedPricingViewNameSlotted(
      jobPricing.MainJobPricingReducer.selectedViewSlottedPk
    );

    return jobPricingGridActions.getSurveysForSlotted(
      slottedJob,
      jobPricing.MainJobPricingReducer.selectedBenchmarkYear,
      marketPricing.displayIn,
      masterAccountId,
      currency.code,
      true,
      selectedSlottedViewName
    );
  }

  showSurveyDataCutsSlideout(survey) {
    const { actions, jobPricing, marketPricing, fieldFormatting } = this.props;
    const { currentJob } = this.state;
    actions.showSlideout(MP_SLIDEOUTS.SURVEY_DATA_CUTS, {
      updateModifiedDate: this.updateModifiedDate,
      currentJob,
      survey,
      benchmarkYear: jobPricing.MainJobPricingReducer.selectedBenchmarkYear,
      displayIn: marketPricing.displayIn,
      monetaryRounding: fieldFormatting.monetaryRounding,
      addSelectedCutID: actions.addSelectedCutID,
      removeSelectedCutID: actions.removeSelectedCutID,
      readOnly: this.isReadOnly(),
      onMatchSelect: this.handleOnMatchSelect
    });
  }

  isEditPastYears() {
    const { editPastYears, editPastYearsGroup, sameOrgAndGroup } = this.props;
    if (sameOrgAndGroup || editPastYearsGroup === undefined || editPastYearsGroup === null) {
      // If in the site level group, use the site settings
      // If the group settings aren't configured for this group, fall back to the site settings
      return editPastYears;
    }

    return editPastYearsGroup;
  }

  isReadOnly() {
    const { jobPricing, readOnlyUser, defaultBenchmarkYear } = this.props;
    const isPastYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear < defaultBenchmarkYear;

    if ((readOnlyUser && !isAdHocJobId(this.getJobId())) || (isPastYear && !this.isEditPastYears())) {
      return true;
    }

    return false;
  }

  getSurveyJobDetailsPageHref(cutId) {
    const { organizationCode } = this.props;
    return `${window.location.origin}/view/o/${organizationCode}/mp/iframe/merit/merit-admin/survey_lib-3?one_cut_id=${cutId}`;
  }

  getSlottedJobPageHref(orgJobId) {
    const { organizationCode } = this.props;
    return `${window.location.origin}/view/o/${organizationCode}/mp/market-analysis/jobs/${orgJobId}/pricing`;
  }

  openSlottedJob(orgJobId) {
    const { organizationCode } = this.props;
    const url = `${window.location.origin}/view/o/${organizationCode}/mp/market-analysis/jobs/${orgJobId}/pricing`;
    window.open(url, '_blank');
  }

  render() {
    const {
      currentJob,
      renderPopover,
      selectedAddMatchesIndex,
      selectedRowId,
      selectedTabIndex,
      showMinHeader
    } = this.state;

    const {
      actions,
      defaultBenchmarkYear,
      defaultWeighting,
      featureFlags,
      fieldFormatting,
      group,
      internalJobs,
      isJobMatchUpdateFailed,
      isJobMatchUpdating,
      isSavingDataCutChangesComplete,
      jobPricing,
      jobPricingGridActions,
      jobMatchGridActions,
      launchDarklyFeatureFlags,
      location,
      marketplaceMatches,
      marketplaceMatchesActions,
      marketplaceMatchesGridActions,
      marketPricing,
      masterAccountId,
      organizationCode,
      participationMatches,
      participationMatchesActions,
      participationMatchesGridActions,
      readOnlyUser,
      replacementTokens,
      siteSettings,
      slottedSearch,
      slottedSearchActions,
      slottedSearchFacetActions,
      slottedSearchGridActions,
      surveyLibrary,
      surveyLibraryFacetActions,
      surveyLibraryGridActions,
      useJobCodeKey,
      uniqueSalaryRange,
      restrictedUser
    } = this.props;

    const showAiMatching = featureFlags.find(flag => flag.name === 'showAiMatching')?.enabled;

    const selectedSurveys = jobPricing.MainJobPricingReducer.selectedCutIDs;
    const selectedSlottedJobs = jobPricing.MainJobPricingReducer.selectedSlottedJobs;
    const isGetJobPricingFailed = !!jobPricing.JobPricingGridReducer.error;
    const isAdHocJob = this.isAdHocJob();
    const viewLoading =
      marketPricing?.surveyViews?.loading ||
      marketPricing?.surveySelectedView?.loading ||
      marketPricing?.setSurveyView?.loading ||
      marketPricing?.changeStatus?.loading ||
      slottedSearch?.slottedSearchReducer?.slottedSearchViews?.loading ||
      slottedSearch?.slottedSearchReducer?.slottedSearchSelectedView?.loading ||
      slottedSearch?.slottedSearchReducer?.setSlottedSearchSelectedView?.loading;

    const jobId = this.getJobId();

    const benchmarkYear = jobPricing.MainJobPricingReducer.selectedBenchmarkYear || defaultBenchmarkYear;
    const displayIn = marketPricing.displayIn;
    const viewSwitcherClassNames = classnames('market-pricing__view-switcher');

    const orgJobCode = currentJob?.code;
    const orgJobCodeKey = !currentJob?.codeKey || currentJob?.codeKey === ' ' ? 'Not Set' : currentJob?.codeKey;
    const orgJobCodeKeyLabel =
      replacementTokens.find(token => token.token === 'job_code_key_text')?.value || 'Job Code Key';

    const subLabelList = [{ label: 'Job Code', text: orgJobCode }];
    if (useJobCodeKey) subLabelList.push({ label: orgJobCodeKeyLabel, text: orgJobCodeKey });
    subLabelList.push({ label: 'Currency', text: this.state.currency });
    subLabelList.push({ label: 'Selected Benchmark Year', text: benchmarkYear });

    const marketPricingTitleClass = classnames('market-pricing__title', { adhoc__title: isAdHocJob });
    const surveyCodeIndex = getColumnIndex(jobPricing.JobPricingGridReducer, 'survey_code');
    const crowdSourcedSurveyCode = `PAY-${organizationCode.toUpperCase()}`;
    const hasCrowdSourcedMatch = !!jobPricing.JobPricingGridReducer?.data?.find(survey =>
      survey[surveyCodeIndex]?.includes(crowdSourcedSurveyCode)
    );
    const isReadOnly = this.isReadOnly();
    const showAddCrowdSourcedMatch = featureFlags.find(flag => flag.name === 'showAddCrowdSourcedMatch').enabled;
    const hideCrowdSourcedButton =
      !showAddCrowdSourcedMatch ||
      !['USD', 'CAD'].includes(this.state.currency) ||
      isAdHocJob ||
      isReadOnly ||
      this.isOnSlotPage();
    const hideAddRegressionSurveyJobButton = !['USD', 'CAD', null].includes(this.state.currency) || isReadOnly;

    const tabListWithCounts =
      (this.isOnSlotPage() ? selectedSlottedJobs.length : selectedSurveys.length) > 0
        ? this.getTabList().map(tab =>
            tab === 'Pricing Details' || tab === 'Slotted Details'
              ? `${tab} (${this.isOnSlotPage() ? selectedSlottedJobs.length : selectedSurveys.length})`
              : tab
          )
        : this.getTabList();
    const currentJobTitle = currentJob?.title || <div className="market-pricing__job-title-loading"></div>;

    const availableAddTabs = this.getAddMatchesList(this.isAdHocJob());

    const activeAddTabIndex = availableAddTabs.findIndex(
      tab => tab === Object.keys(this.tabMapping).find(key => this.tabMapping[key] === this.state.selectedAddMatchesIndex)
    );

    return (
      <div className="market-pricing__container">
        <div className={classnames('market-pricing__header', { adhoc: isAdHocJob, min: showMinHeader })}>
          <div className="market-pricing__actions">
            <Link
              className="return__link"
              to={{
                pathname: '/market-analysis/market-pricing',
                state: {
                  notFirstLoad: true,
                  searchQuery: location?.state?.searchQuery,
                  offset: location?.state?.offset
                }
              }}
              onClick={() => {
                actions.hideSlideout();
              }}
            >
              <i className="icon-reply" />
              Return to Jobs List
            </Link>
            <div className="pricing-dropdowns">
              {jobPricing.MainJobPricingReducer.lastModifiedDate ? (
                <React.Fragment>
                  <span className="last-modified__text">
                    {`Last Updated ${shortDateString(new Date(jobPricing.MainJobPricingReducer.lastModifiedDate))}`}
                  </span>
                  <a className="last-modified__link" href={this.getAuditTrailUrl()} target="_blank" rel="noreferrer">
                    View Pricing Audit
                  </a>
                </React.Fragment>
              ) : jobPricing.MainJobPricingReducer.lastModifiedDate === 0 ? null : (
                <div className={classnames('dropdown-loading', { adhoc: isAdHocJob })}></div>
              )}
              {this.renderDropdowns()}
            </div>
          </div>

          <div className="market-pricing-title__container">
            <div className={marketPricingTitleClass}>
            <Tooltip maw='80%' multiline transitionProps={{ transition: 'fade-up', duration: 500 }} label={currentJob?.description} openDelay={350} withArrow disabled={!currentJob?.description}>
              <div className="market-pricing__title-text">
                {isAdHocJob ? 'Create Ad hoc Pricing' : currentJobTitle}
                <SlotteeInfo
                  hide={!currentJob?.usedJobs || currentJob?.usedJobs?.length === 0 || this.isOnSlotPage()}
                  usedJobs={currentJob?.usedJobs}
                />
              </div>
            </Tooltip>
              {!isAdHocJob && currentJob?.title ? (
                <SubLabelList subLabels={subLabelList} />
              ) : (
                <div className={classnames('market-pricing__job-labels-loading', { adhoc: isAdHocJob })}></div>
              )}
            </div>
            {this.renderAboutJobDropdown()}
          </div>
        </div>

        <div className={classnames('market-pricing__header min-header', { adhoc: isAdHocJob, min: showMinHeader })}>
          <div className="market-pricing-title__container">
            <div className={marketPricingTitleClass}>
            <span className="market-pricing__title-text">
                {isAdHocJob ? 'Create Ad hoc Pricing' : currentJob?.title}
              </span>
            </div>
            {this.renderAboutJobDropdown()}
          </div>
        </div>

        <div
          className={classnames('market-pricing__tab-container', {
            extended: selectedTabIndex === SEARCH_TAB && !this.isOnSlotPage()
          })}
        >

          <ViewSwitcher
            isSticky={true}
            className={viewSwitcherClassNames}
            tabList={tabListWithCounts}
            activeTab={this.state.selectedTabIndex}
            tabSwitch={this.switchTab}
            isDisabled={marketPricing.loadingId != null}
          />
          {this.state.selectedTabIndex === SEARCH_TAB && !this.isOnSlotPage() && (
            <ViewSwitcher
              isSticky={true}
              className={classnames('market-pricing__add-matches-tabs', { min: showMinHeader })}
              tabList={this.getAddMatchesList(this.isAdHocJob())}
              activeTab={activeAddTabIndex}
              tabSwitch={this.switchAddMatches}
              showIndicator={(tabIndex) => tabIndex === AI_MATCHING && this.getAddMatchesList(this.isAdHocJob()).includes('AI Matching')}
              indicatorText='NEW'
            />
          )}
        </div>

        <div className="market-pricing__tab-panel">
          {this.state.currentJob && this.state.selectedTabIndex === SEARCH_TAB && !this.isOnSlotPage() && (
            <React.Fragment>
              {selectedAddMatchesIndex === SURVEY_LIBRARY_MATCHES && (
                <SurveyLibrary
                  addMatch={actions.addMatch}
                  addSelectedCutID={actions.addSelectedCutID}
                  aging={jobPricing.MainJobPricingReducer.selectedAgingFactor}
                  currency={this.state.currency}
                  currencies={this.props.currencies}
                  currentJob={this.state.currentJob}
                  deleteMatch={actions.deleteMatch}
                  displayIn={marketPricing.displayIn}
                  getSurveyJobDetailsPageHref={this.getSurveyJobDetailsPageHref}
                  hasCrowdSourcedMatch={hasCrowdSourcedMatch}
                  hideAddPrivateSurveyJobButton={isReadOnly}
                  hideCrowdSourcedButton={hideCrowdSourcedButton}
                  hideAddRegressionSurveyJobButton={hideAddRegressionSurveyJobButton}
                  hideSelect={isReadOnly}
                  history={this.props.history}
                  isAdHoc={this.isAdHocJob()}
                  isMatchDeleting={marketPricing.isMatchDeleting}
                  loadingId={marketPricing.loadingId}
                  location={location}
                  masterAccountId={masterAccountId}
                  numericRounding={fieldFormatting.numericRounding}
                  onDataCutClick={this.showSurveyDataCutsSlideout}
                  onMatchSelect={this.handleOnMatchSelect}
                  percentRounding={fieldFormatting.percentRounding}
                  refreshJobTabData={this.handlePricingChange}
                  removeSelectedCutID={actions.removeSelectedCutID}
                  renderPopover={renderPopover}
                  selectedBenchmarkYear={jobPricing.MainJobPricingReducer.selectedBenchmarkYear}
                  selectedRowId={selectedRowId}
                  selectedSurveys={selectedSurveys}
                  selectedViewPk={marketPricing.surveySelectedView?.selectedViewPk}
                  setCurrency={this.setCurrency}
                  showMinHeader={showMinHeader}
                  showSlideout={actions.showSlideout}
                  surveyLibraryFacet={surveyLibrary.SurveyLibraryFacetReducer}
                  surveyLibraryFacetActions={surveyLibraryFacetActions}
                  surveyLibraryGrid={surveyLibrary.SurveyLibraryGridReducer}
                  surveyLibraryGridActions={surveyLibraryGridActions}
                  toggleHeader={this.toggleHeader}
                  togglePopover={this.togglePopover}
                  updateModifiedDate={this.updateModifiedDate}
                  updatePricingGrid={jobPricingGridActions.search}
                />
              )}
              {selectedAddMatchesIndex === AI_MATCHING && this.props.launchDarklyFeatureFlags['ai-matching'] && showAiMatching && !this.isAdHocJob() && (
                <AIMatching
                  state={this.state}
                  parentProps={this.props}
                  actions={actions}
                  getSurveyJobDetailsPageHref={this.getSurveyJobDetailsPageHref}
                  hasCrowdSourcedMatch={hasCrowdSourcedMatch}
                  isReadOnly={isReadOnly}
                  showSurveyDataCutsSlideout={this.showSurveyDataCutsSlideout}
                  selectedViewPk={marketPricing.surveySelectedView?.selectedViewPk}
                  onMatchSelect={this.handleOnMatchSelect}
                  hideCrowdSourcedButton={hideCrowdSourcedButton}
                  hideAddRegressionSurveyJobButton={hideAddRegressionSurveyJobButton}
                  handlePricingChange={this.handlePricingChange}
                  renderPopover={renderPopover}
                  selectedSurveys={selectedSurveys}
                  setCurrency={this.setCurrency}
                  surveyLibraryFacetActions={surveyLibraryFacetActions}
                  updateModifiedDate={this.updateModifiedDate}
                />
              )}
              {selectedAddMatchesIndex === COPY_MATCHES && (
                <InternalJobsContainer
                  currency={this.state.currency}
                  currentJob={this.state.currentJob}
                  getSurveyJobDetailsPageHref={this.getSurveyJobDetailsPageHref}
                  hideSelect={isReadOnly}
                  internalJobsGridActions={internalJobsGridActions}
                  isAdHoc={this.isAdHocJob()}
                  onDataCutClick={this.showSurveyDataCutsSlideout}
                  onMatchSelect={this.handleOnMatchSelect}
                  refreshJobTabData={this.handlePricingChange}
                  renderPopover={renderPopover}
                  replacementTokens={replacementTokens}
                  selectedRowId={selectedRowId}
                  selectedSurveys={selectedSurveys}
                  showMinHeader={showMinHeader}
                  toggleHeader={this.toggleHeader}
                  togglePopover={this.togglePopover}
                  updateModifiedDate={this.updateModifiedDate}
                  useJobCodeKey={useJobCodeKey}
                  viewLoading={viewLoading}
                />
              )}

              <MarketplaceMatches
                {...marketplaceMatches.marketplaceMatchesReducer}
                actions={{
                  ...marketplaceMatchesActions,
                  ...marketplaceMatchesGridActions,
                  showSlideout: actions.showSlideout,
                  hideSlideout: actions.hideSlideout
                }}
                addMatch={actions.addMatch}
                addSelectedCutID={actions.addSelectedCutID}
                benchmarkYear={jobPricing.MainJobPricingReducer.selectedBenchmarkYear}
                currency={this.props.jobs[0]?.currency || 'USD'}
                deleteMatch={actions.deleteMatch}
                displayIn={marketPricing.displayIn}
                getSurveyJobDetailsPageHref={this.getSurveyJobDetailsPageHref}
                grid={marketplaceMatches.marketplaceMatchesGridReducer}
                groupId={group?.groupId}
                handlePricingChange={this.handlePricingChange}
                hideSelect={isReadOnly}
                isAdHoc={this.isAdHocJob()}
                isGetJobPricingLoaded={jobPricing.JobPricingGridReducer.loaded}
                isGetJobPricingLoading={jobPricing.JobPricingGridReducer.loading}
                isMatchDeleting={marketPricing.isMatchDeleting}
                jobId={jobId}
                jobPricingGrid={jobPricing.JobPricingGridReducer}
                loadingId={marketPricing.loadingId}
                masterAccountId={masterAccountId}
                numericRounding={fieldFormatting.numericRounding}
                onDataCutClick={this.showSurveyDataCutsSlideout}
                percentRounding={fieldFormatting.percentRounding}
                removeSelectedCutID={actions.removeSelectedCutID}
                render={selectedAddMatchesIndex === MARKETPLACE_MATCHES}
                renderPopover={renderPopover}
                selectedRowId={selectedRowId}
                selectedSurveys={selectedSurveys}
                selectedViewPk={marketPricing.surveySelectedView?.selectedViewPk}
                showMinHeader={showMinHeader}
                toggleHeader={this.toggleHeader}
                togglePopover={this.togglePopover}
                updateModifiedDate={this.updateModifiedDate}
                viewLoading={viewLoading}
                launchDarklyFeatureFlags={launchDarklyFeatureFlags}
              />

              <ParticipationMatchesContainer
                {...participationMatches.participationMatchesReducer}
                actions={{
                  ...participationMatchesActions,
                  ...participationMatchesGridActions
                }}
                addMatch={actions.addMatch}
                addSelectedCutID={actions.addSelectedCutID}
                benchmarkYear={jobPricing.MainJobPricingReducer.selectedBenchmarkYear}
                currency={this.props.jobs[0]?.currency || 'USD'}
                currentJob={this.state.currentJob}
                deleteMatch={actions.deleteMatch}
                displayIn={marketPricing.displayIn}
                getSurveyJobDetailsPageHref={this.getSurveyJobDetailsPageHref}
                grid={participationMatches.participationMatchesGridReducer}
                groupId={group?.groupId}
                handlePricingChange={this.handlePricingChange}
                hideSelect={isReadOnly}
                isAdHoc={this.isAdHocJob()}
                isGetJobPricingLoaded={jobPricing.JobPricingGridReducer.loaded}
                isGetJobPricingLoading={jobPricing.JobPricingGridReducer.loading}
                isMatchDeleting={marketPricing.isMatchDeleting}
                jobId={jobId}
                jobPricingGrid={jobPricing.JobPricingGridReducer}
                loadingId={marketPricing.loadingId}
                masterAccountId={masterAccountId}
                numericRounding={fieldFormatting.numericRounding}
                onDataCutClick={this.showSurveyDataCutsSlideout}
                organizationCode={organizationCode}
                percentRounding={fieldFormatting.percentRounding}
                removeSelectedCutID={actions.removeSelectedCutID}
                render={selectedAddMatchesIndex === PARTICIPATION_MATCHES}
                renderPopover={renderPopover}
                selectedRowId={selectedRowId}
                selectedSurveys={selectedSurveys}
                selectedViewPk={marketPricing.surveySelectedView?.selectedViewPk}
                showMinHeader={showMinHeader}
                toggleHeader={this.toggleHeader}
                togglePopover={this.togglePopover}
                updateModifiedDate={this.updateModifiedDate}
                viewLoading={viewLoading}
              />
            </React.Fragment>
          )}

          {this.state.currentJob && this.state.selectedTabIndex === SEARCH_TAB && this.isOnSlotPage() && (
            <SlottedJobSearch
              actions={{
                ...slottedSearchGridActions,
                ...slottedSearchFacetActions,
                ...slottedSearchActions
              }}
              activeBenchmarkYear={defaultBenchmarkYear}
              addMatch={actions.addMatch}
              aging={getCurrentAgingCode(jobPricing.JobPricingGridReducer)}
              currency={this.state.currency}
              currentJob={this.state.currentJob}
              deleteMatch={actions.deleteMatch}
              displayIn={marketPricing.displayIn}
              facet={slottedSearch.slottedSearchFacetReducer}
              grid={slottedSearch.slottedSearchGridReducer}
              hideSelect={isReadOnly}
              history={this.props.history}
              isMatchDeleting={marketPricing.isMatchDeleting}
              loadingId={marketPricing.loadingId}
              location={location}
              masterAccountId={masterAccountId}
              numericRounding={fieldFormatting.numericRounding}
              onMatchSelect={this.handleOnMatchSelect}
              percentRounding={fieldFormatting.percentRounding}
              readOnlyUser={readOnlyUser}
              refreshJobTabData={this.handlePricingChange}
              replacementTokens={replacementTokens}
              selectedBenchmarkYear={jobPricing.MainJobPricingReducer.selectedBenchmarkYear}
              selectedRowId={selectedRowId}
              selectedSlottedJobs={selectedSlottedJobs}
              showMinHeader={showMinHeader}
              showSlideout={actions.showSlideout}
              slottedSearch={slottedSearch.slottedSearchReducer}
              toggleHeader={this.toggleHeader}
              updateModifiedDate={this.updateModifiedDate}
              updatePricingGrid={jobPricingGridActions.search}
              useJobCodeKey={useJobCodeKey}
              viewLoading={viewLoading}
            />
          )}

          {this.state.currentJob && this.state.selectedTabIndex === DETAILS_TAB && (
            <JobPricingContainer
              activeBenchmarkYear={defaultBenchmarkYear}
              benchmarkYear={benchmarkYear}
              currentJob={this.state.currentJob}
              defaultWeighting={defaultWeighting}
              deleteMatch={actions.deleteMatch}
              displayIn={displayIn}
              getJobPricingDetails={actions.getJobPricingDetails}
              getJobPricingSurveys={actions.getJobPricingSurveys}
              getPricingDetailsForSlottedJob={this.getPricingDetailsForSlottedJob}
              getRangeChartData={actions.getRangeChartData}
              getSlottedJobPageHref={this.getSlottedJobPageHref}
              getSurveyJobDetailsPageHref={this.getSurveyJobDetailsPageHref}
              isEditPastYears={this.isEditPastYears()}
              isGetJobPricingFailed={isGetJobPricingFailed}
              isGetJobPricingLoading={jobPricing.JobPricingGridReducer.loading}
              isJobMatchUpdateFailed={isJobMatchUpdateFailed}
              isJobMatchUpdating={isJobMatchUpdating}
              isOnSlotPage={this.isOnSlotPage()}
              isPriced={this.isPriced()}
              isPricingMatchDeleteFailed={jobPricing.isPricingMatchDeleteFailed}
              isPricingMatchDeleting={marketPricing.isMatchDeleting}
              isReadOnly={isReadOnly}
              isSavingDataCutChangesComplete={isSavingDataCutChangesComplete}
              isSlottedJob={this.isSlotted()}
              isUpdatingAgingFactor={jobPricing.isUpdatingAgingFactor}
              isUpdatingAgingFactorFailed={jobPricing.isUpdatingAgingFactorFailed}
              isUpdatingMeritMatchSummaries={jobPricing.isUpdatingMeritMatchSummaries}
              isUpdatingMeritMatchSummariesFailed={jobPricing.isUpdatingMeritMatchSummariesFailed}
              jobPricing={jobPricing.MainJobPricingReducer}
              jobPricingGrid={jobPricing.JobPricingGridReducer}
              jobPricingGridActions={jobPricingGridActions}
              masterAccountId={masterAccountId}
              monetaryRounding={fieldFormatting.monetaryRounding}
              numericRounding={fieldFormatting.numericRounding}
              onDataCutClick={this.showSurveyDataCutsSlideout}
              onPricingChange={this.handlePricingChange}
              openCompSummary={this.openCompSummary}
              percentRounding={fieldFormatting.percentRounding}
              rangeChartData={jobPricing.MainJobPricingReducer.rangeChartData}
              rangeChartError={jobPricing.MainJobPricingReducer.rangeChartError}
              rangeChartLoaded={jobPricing.MainJobPricingReducer.rangeChartLoaded}
              rangeChartLoading={jobPricing.MainJobPricingReducer.rangeChartLoading}
              readOnlyUser={readOnlyUser}
              restrictedUser={restrictedUser}
              renderAgingDropdown={this.renderAgingDropdown}
              renderBenchmarkYearDropdown={this.renderBenchmarkYearDropdown}
              renderPopover={renderPopover}
              reportDropdownOption={marketPricing.reportDropdownOption}
              resetReportDropdown={this.resetReportDropdown}
              selectedBenchmarkYear={jobPricing.MainJobPricingReducer.selectedBenchmarkYear}
              selectedRowId={selectedRowId}
              selectedSlottedJobs={selectedSlottedJobs}
              selectedSurveys={selectedSurveys}
              selectedViewPk={jobPricing.MainJobPricingReducer.selectedViewPk}
              selectedViewSlottedPk={jobPricing.MainJobPricingReducer.selectedViewSlottedPk}
              jobMatchGridActions={jobMatchGridActions}
              showDifferentialsSlideout={this.showDifferentialsSlideout}
              showSlideout={actions.showSlideout}
              showYearOverYearSlideout={this.showYearOverYearSlideout}
              siteSettings={siteSettings}
              togglePopover={this.togglePopover}
              updateJobMatchesValues={actions.updateJobMatchesValues}
              updateMeritMatchSummaries={actions.updateMeritMatchSummaries}
              updateModifiedDate={this.updateModifiedDate}
              useJobCodeKey={useJobCodeKey}
              usePropagateMatches={featureFlags.find(flag=> flag.name === 'usePropagateMatches').enabled}
              uniqueSalaryRange={uniqueSalaryRange}
            />
          )}

          {!this.state.currentJob && <InPlaceIndicator />}
        </div>

        <Modal ref={this.usedJobsModal} className="market-pricing__used-jobs-modal" displayCloseButton={true}>
          <React.Fragment>
            <ModalHeader className="used-jobs__header">
              <h3 className="text">To slot this job, remove it as a slottee match for other jobs</h3>
            </ModalHeader>
            <ModalBody className="used-jobs__body">
              <Fragment>
                <p className="used-jobs__text">
                  Jobs cannot be slotted to another slotted job. Please remove it as a slottee match for the following
                  jobs
                </p>

                <div className={classnames('used-jobs__list', { 'no-scroll': this.state.usedJobs?.length < 7 })}>
                  {this.getUsedModalJobs()}
                </div>
              </Fragment>
            </ModalBody>
          </React.Fragment>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({
  aging,
  compensationSummary,
  currency,
  group,
  jobDetailsData,
  jobEmployees,
  marketPricing,
  orgJobs,
  session,
  skillGeoDifferential,
  surveyJobDataCuts
}) => {
  return {
    group,
    /*  Market Pricing ****************************** */
    internalJobs: marketPricing.InternalJobsReducer,
    jobPricing: marketPricing.JobPricingReducer,
    marketplaceMatches: marketPricing.MarketplaceMatchesReducer,
    marketPricing: marketPricing.MarketPricingReducer,
    participationMatches: marketPricing.ParticipationMatchesReducer,
    slottedSearch: marketPricing.SlottedSearchReducer,
    surveyLibrary: marketPricing.SurveyLibraryReducer,
    /*  Aging ****************************** */
    benchmarkYears: aging.benchmarkYears,
    isAgingReducerLoaded: aging.loaded,
    /* skillGeoDifferential ****************************** */
    adHocJob: skillGeoDifferential.adHocJob,
    /* Session ****************************** */
    defaultBenchmarkYear: session.benchmarkYear,
    hasHRTMSIntegration: session.organization?.accountMetaData?.enableHRTMSIntegration,
    currency: session.currency,
    defaultWeighting: session.defaultWeighting,
    editPastYears: session.organization.accountMetaData.editPastYears,
    editPastYearsGroup: session.groupMetaData.editPastYears,
    featureFlags: session.featureFlags,
    fieldFormatting: {
      monetaryRounding: session.user.preferences.monetaryRounding,
      numericRounding: session.user.preferences.numericRounding,
      percentRounding: session.user.preferences.percentRounding
    },
    masterAccountId: session.organization.masterAccountId,
    organizationCode: session.organization.code,
    readOnlyUser: session.user.rights.readOnlyUser,
    restrictedUser: session.user.rights.restrictedUser,
    replacementTokens: session.replacementTokens,
    sameOrgAndGroup: session.group.id === session.organization.defaultGroup.id,
    useJobCodeKey: session.organization.useJobCodeKey,
    userRights: session.user.rights,
    groupAdminCanConfigureViews: session.groupAdminCanConfigureViews,
    regularUserCanConfigureViews: session.regularUserCanConfigureViews,
    useCurrencyBasedAgingFactor: session.useCurrencyBasedAgingFactor,
    /* Currency ****************************** */
    currencies: currency.currencies,
    /* OrgJobs ****************************** */
    agingFactors: orgJobs.agingFactors,
    isAgingFactorsLoaded: orgJobs.isAgingFactorsLoaded,
    isJobMatchUpdateFailed: orgJobs.isUpdatingJobMatchesValuesFailed,
    isJobMatchUpdating: orgJobs.isUpdatingJobMatchesValues,
    isLoadingOrgJob: orgJobs.isLoading,
    isLoadingOrgJobFailed: orgJobs.isLoadingFailed,
    isSavingDataCutChangesComplete: surveyJobDataCuts.isSavingDataCutChangesComplete,
    jobs: orgJobs.jobs,
    /*  CompensationSummary ****************************** */
    siteSettings: {
      showAgingFactor: compensationSummary.showAgingFactor,
      showGeoAdjustment: compensationSummary.showGeoAdjustment,
      showWgtBy: compensationSummary.showWgtBy,
      useParticipationMatch: compensationSummary.useParticipationMatch
    },
    uniqueSalaryRange: session.uniqueSalaryRange,
    jobEmployeesData: jobEmployees.JobEmployeesMainReducer.jobEmployeesData,
    jobEmployeesLimit: jobEmployees.JobEmployeesGridReducer.limit,
    jobEmployeesOffset: jobEmployees.JobEmployeesGridReducer.offset,
    selectedEmployeesViewPk: jobEmployees.JobEmployeesMainReducer.employeeSelectedView?.selectedViewPk,
    selectedJobDetailsViewPk: jobDetailsData.jobDetailsSelectedView?.selectedViewPk
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      addMatch,
      addSelectedCutID,
      changeStatus,
      createAdHocJob,
      deleteMatch,
      downloadJobDescription,
      getAgingFactors,
      getConfigSettings,
      getEmployeeSelectedView,
      getJobDetailsSelectedView,
      getJobEmployees,
      getHeaderInfo,
      getJobByID,
      getJobPricingDetails,
      getLastModifiedDate,
      getOverallComposite,
      getPricingViews,
      getRangeChartData,
      getSelectedPricingView,
      getSelectedSurveyView,
      getSurveyViews,
      hideSlideout,
      initializeSaveJobPricingWithJob,
      removeSelectedCutID,
      resetInternalJobsReducer,
      resetJobPricingReducer,
      resetOrgJobsLoading,
      resetReportDropdown,
      setBenchmarkYearCSR,
      setDisplayIn,
      setDisplayInCSR,
      setReportDropdown,
      setSelectedAgingFactor,
      setSelectedBenchmarkYear,
      setSelectedPricingView,
      setSelectedSurveyView,
      setYearOverYearDisplayIn,
      showSlideout,
      updateAgingFactor,
      updateJobMatchesValues,
      updateMeritMatchSummaries,
      updateSelectJob
    },
    dispatch
  ),
  jobMatchGridActions: bindActionCreators({ ...jobMatchGridActions }, dispatch),
  internalJobsGridActions: bindActionCreators(
    {
      ...internalJobsGridActions
    },
    dispatch
  ),
  surveyLibraryGridActions: bindActionCreators(
    {
      ...surveyLibraryGridActions
    },
    dispatch
  ),
  surveyLibraryFacetActions: bindActionCreators(
    {
      ...surveyLibraryFacetActions
    },
    dispatch
  ),
  jobPricingGridActions: bindActionCreators(
    {
      ...jobPricingGridActions
    },
    dispatch
  ),
  marketplaceMatchesActions: bindActionCreators(
    {
      ...marketplaceMatchesActions
    },
    dispatch
  ),
  marketplaceMatchesGridActions: bindActionCreators(
    {
      ...marketplaceMatchesGridActions
    },
    dispatch
  ),
  participationMatchesActions: bindActionCreators(
    {
      ...participationMatchesActions
    },
    dispatch
  ),
  participationMatchesGridActions: bindActionCreators(
    {
      ...participationMatchesGridActions
    },
    dispatch
  ),
  slottedSearchGridActions: bindActionCreators(
    {
      ...slottedSearchGridActions
    },
    dispatch
  ),
  slottedSearchFacetActions: bindActionCreators(
    {
      ...slottedSearchJobFacetSearchActions
    },
    dispatch
  ),
  slottedSearchActions: bindActionCreators(
    {
      ...slottedSearchActions
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketPricingContainer));
